/**
 * Version Update Splash Screen
 *
 * Displays a brief splash screen when the app version changes
 * and storage is being cleared. This provides user feedback
 * during the update process.
 */

import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getCurrentVersion } from '@/utils/versionCheck';

const VersionUpdateSplash: React.FC = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff',
                zIndex: 9999
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3
                }}
            >
                <CircularProgress size={60} />
                <Typography variant="h5" color="primary" fontWeight={600}>
                    Updating to version {getCurrentVersion()}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Clearing cached data and preparing fresh application state...
                </Typography>
            </Box>
        </Box>
    );
};

export default VersionUpdateSplash;
